import { z } from "zod";

import { ERROR_MSG } from "@/constants/ErrorMessage.constant";
import { imageValidator } from "@/lib/validators";

export const WasteDocuments = z.object({
  name: z
    .string({
      required_error: "Document Name is required.",
    })
    .trim()
    .min(2, {
      message: "Document Name is too short.",
    })
    .max(50, {
      message: "Document Name is too long.",
    }),
  document: z
    .any()
    .refine((data: File) => {
      if (Object.keys(data || []).length === 0) {
        return false;
      }

      return true;
    }, "Document is required")
    .refine((data: FileList) => {
      let isSizeValid = true;
      Object.values(data || []).forEach((data) => {
        if (data.size > 2 * 1024 * 1024) {
          isSizeValid = false;
        }
      });

      return isSizeValid;
    }, "Document should be smaller than 2MB"),
});

export type TWasteDocument = z.infer<typeof WasteDocuments>;

export const ReportSetting = z.object({
  headerImage: imageValidator(2, false, ERROR_MSG.INVALID_IMAGE),
  headerOpacity: z.coerce.number().min(0).max(100),
  headerActive: z.boolean(),
  footerImage: imageValidator(2, false, ERROR_MSG.INVALID_IMAGE),
  footerOpacity: z.coerce.number().min(0).max(100),
  footerActive: z.boolean(),
  watermarkImage: imageValidator(2, false, ERROR_MSG.INVALID_IMAGE),
  watermarkOpacity: z.coerce.number().min(0).max(100),
  watermarkScale: z.coerce.number().min(0).max(100),
  watermarkActive: z.boolean(),
});

export type TReportSetting = z.infer<typeof ReportSetting>;
